import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PaymentHistoryDetails } from 'src/app/models/payment-history.model';
import { InvoiceDataService } from 'src/app/services/invoice-data.service';

@Component({
  selector: 'app-payment-history-details',
  templateUrl: './payment-history-details.component.html',
  styleUrls: ['./payment-history-details.component.scss']
})
export class PaymentHistoryDetailsComponent implements OnInit {
  paymentHistory?: PaymentHistoryDetails;
  id: string = '';
  currency: string = '';

  constructor(private route: ActivatedRoute, private toastr: ToastrService, private invoiceDataService: InvoiceDataService){}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id') || '';
    this.currency = localStorage.getItem('currency') || '';
    this.getSelectedInvoiceData(parseInt(this.id));
  }

  getSelectedInvoiceData(id: number) {
    this.invoiceDataService.getDetailsById(id).subscribe(
      (data) => {
        var response = data.body;
        if(response?.status === 'OK') {
          this.paymentHistory = data?.body?.data as PaymentHistoryDetails;
        }else{
          this.toastr.error(response?.message);
        }
      },
      () => {
        this.toastr.error('An error ocurred.');
      }
    );
  }

  formatCamelCase(value: string | null | undefined): string {
    if (!value) return '----';
    return value.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/\s+/g, ' ').trim();
  }
}
